<template>
  <div class="fix-5-12 max-w-448px w-full ml-auto mr-auto">
    <ul
      class="slider clickable ae-1 fromRight text-center opacity-100"
      :data-slider-id="slideDatas.sliderID"
    >
      <SliderOneContent
        v-for="(mjSlider, i) in slideDatas.mjSliders"
        :key="i"
        :mjSlider="mjSlider"
      />
    </ul>
    <ul class="controller dots ae-2 fromLeft text-center" :data-slider-id="slideDatas.sliderID">
      <li
        v-for="(mjSliderDot, i) in slideDatas.mjSliders"
        :key="i"
        class="dot p-2 inline-block cursor-pointer"
        :class="[mjSliderDot.active ? 'selected' : '']"
      ></li>
    </ul>
  </div>
</template>

<script>
import SliderOneContent from "./SliderOneContent";

export default {
  name: "SliderOne",
  props: {
    slideDatas: {
      type: Object
    }
  },
  components: {
    SliderOneContent
  }
};
</script>

<style scoped>
</style>